import { DateTime } from "luxon";
import { Lead } from "../../../models/Lead";

export const leadColumns = [
  { label: "Número", index: "number", data: (l: Lead) => l.number ?? "" },
  { label: "Nome", index: "name", data: (l: Lead) => l.name ?? "" },
  { label: "Nome fantasia", index: "tradeName", data: (l: Lead) => l.tradeName ?? "" },
  { label: "CNPJ", index: "cnpj", data: (l: Lead) => l.cnpj ?? "" },
  { label: "Email", index: "email", data: (l: Lead) => l.email ?? "" },
  { label: "Telefone", index: "phone", data: (l: Lead) => l.phone ?? "" },
  {
    label: "Responsável",
    index: "responsibleName",
    data: (l: Lead) => l.responsibleName ?? "",
  },
  {
    label: "Status funil",
    index: "prospectStatusName",
    data: (l: Lead) => l.prospectStatusName ?? "Sem status",
  },
  { label: "UF", index: "state", data: (l: Lead) => l.state ?? "" },
  {
    label: "Criado em",
    index: "createdDate",
    data: (l: Lead) =>
      l.createdDate ? DateTime.fromISO(l.createdDate).toFormat("dd/LL/yyyy") : "",
  },
];

export const defaultLeadColumns = [
  "Número",
  "Nome",
  "Nome fantasia",
  "Responsável",
  "Status funil",
  "UF",
];
